import { css } from '@emotion/react'

// designオブジェクトから必要なプロパティのみを使用
type DesignForCardStyle = {
  theme?: {
    brandColor?: string
  }
  background?: {
    backgroundColor?: string
    cardColor?: string
  }
}

export const getCardStyle = (design: DesignForCardStyle | null | undefined) => {
  return css({
    border: `1px solid ${design?.theme?.brandColor}`,
    backgroundColor: design?.background?.cardColor,
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    minHeight: '42px',
    flex: '0 0 auto',
    padding: '8px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    maxWidth: '100%',
    span: {
      color: design?.theme?.brandColor,
      fontWeight: 'bold',
      textAlign: 'center',
      lineHeight: '1.3',
    },
    'input[type="checkbox"]:checked + span, input[type="radio"]:checked + span': {
      color: design?.background?.cardColor,
    },
    '&:has(input[type="checkbox"]:checked), &:has(input[type="radio"]:checked)': {
      backgroundColor: design?.theme?.brandColor,
    },
  })
}

export const containerStyle = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
  marginTop: '16px',
})

export const inputStyle = css({
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
})
